export default "__VITE_ASSET__COjcF2Uf__"